import './Loading.css';
import classNames, { ArgumentArray as ClassnameArguments } from 'classnames';

export default function Loading({
  size = 1,
  center = true,
}: {
  size?: 1 | 2 | 3;
  center?: boolean; // if not center, then inline
}) {
  const fontSize =
    size === 1 ? 'text-[3px]' : size === 2 ? 'text-[6px]' : 'text-[12px]';
  const topOffset =
    size === 1
      ? 'translate-y-[20px]'
      : size === 2
        ? 'translate-y-[40px]'
        : 'translate-y-[80px]';
  const leftOffset =
    size === 1
      ? 'translate-x-[20px]'
      : size === 2
        ? 'translate-x-[40px]'
        : 'translate-x-[80px]';
  const height =
    size === 1 ? 'h-[40px]' : size === 2 ? 'h-[80px]' : 'h-[160px]';
  const width = center
    ? 'w-full'
    : size === 1
      ? 'w-[40px]'
      : size === 2
        ? 'w-[80px]'
        : 'w-[160px]';
  return (
    <div
      className={classNames(
        fontSize,
        'relative',
        height,
        width,
        !center ? 'inline-block' : undefined
      )}
    >
      <div
        className={classNames(
          'absolute',
          topOffset,
          center ? 'left-1/2' : leftOffset
        )}
      >
        <div className="loaders">
          <div className="loader"></div>
          <div className="loader"></div>
          <div className="loader"></div>
          <div className="loader"></div>
          <div className="loader"></div>
          <div className="loader"></div>
          <div className="loader"></div>
          <div className="loader"></div>
          <div className="loader"></div>
          <div className="loader"></div>
        </div>
        <div className="loadersB">
          <div className="loaderA">
            <div className="ball0"></div>
          </div>
          <div className="loaderA">
            <div className="ball1"></div>
          </div>
          <div className="loaderA">
            <div className="ball2"></div>
          </div>
          <div className="loaderA">
            <div className="ball3"></div>
          </div>
          <div className="loaderA">
            <div className="ball4"></div>
          </div>
          <div className="loaderA">
            <div className="ball5"></div>
          </div>
          <div className="loaderA">
            <div className="ball6"></div>
          </div>
          <div className="loaderA">
            <div className="ball7"></div>
          </div>
          <div className="loaderA">
            <div className="ball8"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
